<span>
    Toplam {{pagination.dataCount}} kayıt bulundu.
</span>
<ng-template [ngIf]="pagination.maxPageCount > 1">
    <ngb-pagination [rotate]="true" [boundaryLinks]="true" [collectionSize]="pagination.dataCount"
                    [(page)]="pagination.page" [pageSize]="pagination.pagePer" (pageChange)="pageIn($event)" [maxSize]="5" [ellipses]="false"></ngb-pagination>
</ng-template>
